/* eslint no-param-reassign:"off" */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import ApplicationSerializer from '@square/dashboard-data/serializers/application';
export default ApplicationSerializer.extend(EmbeddedRecordsMixin, {
  primaryKey: 'token',
  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    if ('entity' in payload) {
      payload = payload.entity;
    }
    if ('entities' in payload) {
      payload = payload.entities;
    }
    return this._super(store, primaryModelClass, payload, id, requestType);
  },
  pushPayload(store, payload) {
    // provide an id if one is not present
    const modelName = this.toString().split(':')[1];
    const modelClass = store.modelFor(modelName);
    const normalized = this.normalizeSingleResponse(store, modelClass, payload);

    // pushPayload does not return the record.
    // If the record is needed after this function, use peekRecord.
    store.push(normalized);
  }
});